import { render, staticRenderFns } from "./BackView.vue?vue&type=template&id=1e874fde&"
import script from "./BackView.vue?vue&type=script&lang=js&"
export * from "./BackView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports